import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PCIObra'

const UpdateField = (data = {}, config = {}) => APIClient.patch(`${APIPci}/${resourceName}/AlterarValorItem`, data, config)
const UpdateFieldList = (data = [], config = {}) => APIClient.patch(`${APIPci}/${resourceName}/AlterarValorLote`, data, config)
const GetStatusPci = (idObra, config = {}) => APIClient.get(`${APIPci}/${resourceName}/SituacaoPci/obraID/${idObra}`, config)
const UpdateStatusPci = (data = {}, config = {}) => APIClient.patch(`${APIPci}/${resourceName}/AlterarSituacaoPci`, data, config)
const StopWork = (idObra, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/paralisar/obraID/${idObra}`, data, config)
const RestartWork = (idObra, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/retomar/obraID/${idObra}`, data, config)
const GetStoppages = (idObra, config = {}) => APIClient.get(`${APIPci}/${resourceName}/paralisacoes/obraID/${idObra}`, config)
const UpdateStoppage = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/paralisacao`, data, config)
const DeleteStoppage = (id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/paralisacao/${id}`, data, config)
const ToggleNA = (data = {}, config = {}) => APIClient.patch(`${APIPci}/${resourceName}/AlterarNAItem`, data, config)
const GetLogItemModelo = (idPciObra, idItemModelo, config = {}) => APIClient.get(`${APIPci}/${resourceName}/HistoricoAlteracao/pciObraId/${idPciObra}/modeloItemId/${idItemModelo}`, config)
const Automatization = (obraId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Automatizacao?obraID=${obraId}`, data, config)
const AutomatizationByItem = (itemId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Automatizacao/Item/${itemId}`, data, config)
const AutomatizationByContract = (contractId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Automatizacao/Contrato/${contractId}`, data, config)
const Validation = (obraId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Validacao?obraID=${obraId}`, data, config)
const ValidationByItem = (itemId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Validacao/Item/${itemId}`, data, config)
const ValidationByContract = (contractId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Validacao/Contrato/${contractId}`, data, config)
const ValidationByPci = (pciId, data = {}, config = {}) => {
  let pciQuery = ''
  pciId.map(id => { pciQuery += `pcis=${id}&` })
  pciQuery = pciQuery.slice(0, -1)

  return APIClient.post(`${APIPci}/${resourceName}/Validacao/pcis?${pciQuery}`, data, config)
}
const GetConsiderations = (contractId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/Consideracoes/${contractId}`, data, config)
const SaveConsiderations = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Consideracoes`, data, config)
const GetAnnex = (contractId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/anexos/${contractId}`, data, config)
const SaveAnnex = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/anexos`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const RemoveAnnex = (annexId, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/anexos/${annexId}`, data, config)
const DownloadAnnex = (annexId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/anexo/${annexId}`, data, config)
const DownloadLegalReport = (obraId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/juridico/${obraId}`, data, config)
const DownloadLegalContractReport = (obraId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/juridicoContrato/${obraId}`, data, config)
const DownloadStatusReport = (data, config = {}) => APIClient.post(`${APIPci}/${resourceName}/consultstatus/export`, data, config)
const ImportXls = (file, columns, obraMap, columnMap) => {
  const formData = new FormData()
  formData.append('file', file)
  for (const item of columns) {
    formData.append('columns', item)
  }
  for (const item of obraMap) {
    formData.append('obraMap', item)
  }
  for (const item of columnMap) {
    formData.append('columnMap', item)
  }
  return APIClient.post(`${APIPci}/${resourceName}/excelImport`, formData, {
    transformRequest: [(d, headers) => {
      delete headers['Content-Type']
      return d
    }]
  })
}

const WorkPCIRepository = {
  UpdateField,
  UpdateFieldList,
  UpdateStatusPci,
  GetStatusPci,
  StopWork,
  RestartWork,
  GetStoppages,
  UpdateStoppage,
  DeleteStoppage,
  ToggleNA,
  GetLogItemModelo,
  Automatization,
  AutomatizationByItem,
  AutomatizationByContract,
  Validation,
  ValidationByItem,
  ValidationByPci,
  ValidationByContract,
  GetConsiderations,
  SaveConsiderations,
  GetAnnex,
  SaveAnnex,
  RemoveAnnex,
  DownloadAnnex,
  DownloadLegalReport,
  DownloadLegalContractReport,
  DownloadStatusReport,
  ImportXls
}

export default WorkPCIRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/workpci.js